import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { error } from 'console';
import { ToastrService } from 'ngx-toastr';
import { TransferaccountService } from 'src/app/services/transferaccount.service';
import { environment } from 'src/environments/environment';
import { ModuleResolutionKind } from 'typescript';

@Component({
  selector: 'app-account-transfer-existing',
  templateUrl: './account-transfer-existing.component.html',
  styleUrls: ['./account-transfer-existing.component.scss']
})
export class AccountTransferExistingComponent implements OnInit {
  applicationSearchQuery: any;
  customerSearchQuery: any;
  application: any[] = [];
  selectedApplications: any[] = [];
  customerData: any;
  selectedUserName: any;

  data = [];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "Application",
    "Transfer from",
    "Transfer to",
  ];

  isAccessRestricted: boolean = false;

  constructor(
    private transferAccountService: TransferaccountService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    const currentDay = new Date().getDate();
    if (currentDay > 23 && !environment.AccountTransferAllow) {
      this.isAccessRestricted = true;
    }
  }

  applicationSearch() {
    if (!this.applicationSearchQuery) {
      this.application = [];
      this.updateTableData();
      return;
    }
    if (this.applicationSearchQuery) {
      this.selectedApplications = [];
      this.updateTableData();
      this.transferAccountService.getApplications(this.applicationSearchQuery).subscribe((result: any) => {
        if (result && result.length > 0) {
          this.application = result.map((app: any) => ({
            ...app,
            userId: app.userId,
            appRefNo: app.appRefNo
          }));
        } else {
          this.application = [];
          this.toastr.error(result);
        }
      }, (error) => {
        this.application = [];
      });
    }
  }

  isSelected(app: any): boolean {
    return this.selectedApplications.some(a => a.applicationId === app.applicationId);
  }

  toggleSelection(app: any) {
    if (this.isSelected(app)) {
      this.removeApplication(app);
    } else {
      this.selectedApplications.push(app);
      this.updateTableData();
    }
  }

  removeApplication(app: any) {
    this.selectedApplications = this.selectedApplications.filter(a => a.applicationId !== app.applicationId);
    this.updateTableData();
  }

  updateTableData() {
    if(this.customerData!=null){
    const tableRows = this.selectedApplications.map(app => ({
      Application: app.appRefNo,
      'Transfer from': `${app.firstName} ${app.lastName}`,
      'Transfer to': this.customerData ? `${this.customerData.firstName} ${this.customerData.lastName}` : 'Not Selected',

    }));
    this.dataSource.data = tableRows;
    }
    else
      this.dataSource.data = [];
  }
  customerSearch() {
    if (!this.customerSearchQuery) {
      this.customerData = null;
      this.updateTableData();
      return;
    }
    this.customerData = null;
    this.updateTableData();
    this.transferAccountService.getCustomerDetails(this.customerSearchQuery)
      .subscribe(
        (result: any) => {
          if (result && result.length > 0) {
            // const isSameUser = this.application.some(app =>
            //   app.userRefNo === result[0].userRefNo
            // );
            // if (isSameUser) {
            //   this.toastr.error("Application cannot be transferred to the same user");
            //   this.customerData = null;
            //   this.updateTableData();
            //   return;
            // }
            this.customerData = {
              ...result[0],
              userId: result[0].userId || result[0].id
            };
            this.updateTableData();
          }
          else {
            this.toastr.error(result);
            this.customerData = null;
            this.updateTableData();

          }
        },
      (error) => {
        this.customerData = null;
        this.updateTableData();
      });
  }
  submit() {
    if (!this.customerData || this.selectedApplications.length === 0) {
      this.toastr.error("Please select applications and a target user");
      return;
    }

    const payload = {
      applicationIds: this.selectedApplications.map(app => app.applicationId),
      fromUserId: this.selectedApplications[0].userId || this.selectedApplications[0].id,
      toUserId: this.customerData.userId || this.customerData.id
    };

    this.transferAccountService.saveTransferAccount(payload).subscribe(
      (result: any) => {
        if (result && result.length > 0 && result[0].success == true) {
          this.toastr.success("Account transfer request submitted successfully");
          this.selectedApplications = [];
          this.application = [];
          this.customerData = null;
          this.applicationSearchQuery = '';
          this.customerSearchQuery = '';
          this.updateTableData();
        } else {
          this.toastr.error(result[0]?.message || "Oops something went wrong");
        }

      });
  }
  checkIfEnter(keyEvent: KeyboardEvent, type: 'application' | 'customer') {
    if (keyEvent.key === 'Enter') {
      keyEvent.preventDefault();
      if (type === 'application' && this.applicationSearchQuery) {
        this.applicationSearch();
      }
      if (type === 'customer' && this.customerSearchQuery) {
        this.customerSearch();
      }
    }
  }

  preventLeadingSpace(event: Event) {
    const e = event as KeyboardEvent;
    const input = e.target as HTMLInputElement;

    if (e.key === ' ' && input.selectionStart === 0) {
      e.preventDefault();
    }
  }

  restrictSpecialChars(event: any, field: 'applicationSearchQuery' | 'customerSearchQuery') {
    const inputValue = event.target.value;
    const cleanValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
    event.target.value = cleanValue;

    if (field === 'applicationSearchQuery') {
      this.applicationSearchQuery = cleanValue;
    } else if (field === 'customerSearchQuery') {
      this.customerSearchQuery = cleanValue;
    }
  }

  refresh() {
    this.selectedApplications = [];
    this.application = [];
    this.customerData = null;
    this.applicationSearchQuery = '';
    this.customerSearchQuery = '';
  }
}



